import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import Grid from '../components/Grid'
import StripePageTitle from '../components/StripePageTitle'
import StripeTables from '../components/StripeTables'
import StripeCharts from '../components/StripeCharts'
import StripeActiveFilters from '../components/StripeActiveFilters'
import UbliqueContainer from '../components/Container'

import './index.scss'

const PageOutputChartsTable = ({
  title,
  configMenu,
  className,
  stripeCharts,
  stripeTables,
  stripeActiveFilters,
  stripeModal = null
}) => {
  return (
    <UbliqueContainer stripeModal={stripeModal}>
      <Grid className={cn('ublique-page-chart-tables', className)}>
        {title && <StripePageTitle text={title} configMenu={configMenu} />}
        {stripeActiveFilters && (
          <StripeActiveFilters filterProps={stripeActiveFilters} />
        )}
        {stripeCharts && <StripeCharts charts={stripeCharts} />}
        {stripeTables && <StripeTables tables={stripeTables} />}
      </Grid>
    </UbliqueContainer>
  )
}

PageOutputChartsTable.propTypes = {
  // da sistemare con Yup
  title: PropTypes.string,
  className: PropTypes.string,
  configMenu: PropTypes.object,
  stripeCharts: PropTypes.array,
  stripeTables: PropTypes.array,
  stripeActiveFilters: PropTypes.object,
  stripeModal: PropTypes.object
}

export default PageOutputChartsTable
